/**
 * Insert standard UUID dashes into a 32-char hex string. Returns null if the
 * input isn't a recognisable UUID.
 *
 *   "5ec9...e2ea" -> "5ec9...-...-...-...-e2ea"
 */
export function dashifyUuid(uuid?: string | null): string | null {
  if (!uuid) return null;
  const value = uuid.replace(/-/g, '');
  if (!/^[0-9a-fA-F]{32}$/.test(value)) return null;
  return `${value.substring(0, 8)}-${value.substring(8, 12)}-${value.substring(
    12,
    16,
  )}-${value.substring(16, 20)}-${value.substring(20)}`.toLowerCase();
}

/**
 * Normalize a UUID for equality comparison: lowercase, no dashes. Use when
 * matching UUIDs from sources that may strip or keep hyphens differently
 * (e.g. comparing the metrics endpoint's player_uuid against a player record
 * returned by the inventory API).
 */
export function normalizeUuid(uuid: string): string {
  return uuid.toLowerCase().replace(/-/g, '');
}
